import React from "react";

export default ({ onChange }) => (
  <form
    onChange={onChange}
    onSubmit={e => {
      e.preventDefault();
    }}
  >
    <div className="form-group">
      <label htmlFor="name" className="sr-only">
        Name
      </label>
      <input
        autoComplete="off"
        autoFocus
        className="form-control"
        maxLength={255}
        name="name"
        placeholder="Name"
      />
    </div>
  </form>
);



// WEBPACK FOOTER //
// ./src/containers/PermissionsPage/PermissionsFilter.js